import zhcn from './zh-cn.messages.json';
import zhtw from './zh-tw.messages.json';

export const langs = {
  'zh-cn': {
    ...zhcn,
  },
  'zh-tw': {
    ...zhtw,
  },
};
